import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';

@Component({
  selector: 'app-make-moov-header-mobile',
  templateUrl: './make-moov-header-mobile.component.html',
  styleUrls: ['./make-moov-header-mobile.component.scss']
})
export class MakeMoovHeaderMobileComponent extends BaseComponent implements OnInit {

  @Input() firstName: string;
  @Input() lastName: string;
  @Input() initials: string;
  @Input() color: string;
  @Input() wizardState: number;
  @Output() closeWizardEvent = new EventEmitter();
  constructor() {
    super();
   }

  ngOnInit(): void {
    super.ngOnInit();
  }

  closeWizard() {
    this.closeWizardEvent.emit();
  }

}
